export default __webpack_public_path__ + "static/media/no-image.ef2af602.jpg";